export default __webpack_public_path__ + "static/media/CardFinSauna.5358e508.jpg";